import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-between px-[34px]" }
const _hoisted_2 = { class: "flex flex-col mt-12 mb-10 items-center" }
const _hoisted_3 = { class: "flex items-center justify-center mb-4" }
const _hoisted_4 = { class: "font-sourcesanspro-semibold text-lg2" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center justify-center mb-4"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "mb-6" }
const _hoisted_8 = { class: "bg-white/10 rounded-lg p-4" }
const _hoisted_9 = { class: "text-white/70 text-sm mb-2" }
const _hoisted_10 = { class: "flex items-center justify-between" }
const _hoisted_11 = { class: "text-white font-sourcesanspro-semibold text-base" }
const _hoisted_12 = { class: "text-white/70 text-sm" }
const _hoisted_13 = { class: "text-right" }
const _hoisted_14 = { class: "text-white/70 text-sm" }
const _hoisted_15 = { class: "text-white font-sourcesanspro-semibold" }
const _hoisted_16 = { class: "mb-8" }
const _hoisted_17 = { class: "flex items-center mb-4" }
const _hoisted_18 = { class: "font-sourcesanspro-semibold text-lg inline" }
const _hoisted_19 = { class: "bg-gradient-to-r from-[#f9af21]/20 to-[#f9af21]/10 border-2 border-[#f9af21] rounded-lg p-4" }
const _hoisted_20 = { class: "flex items-center justify-between mb-3" }
const _hoisted_21 = { class: "text-white font-sourcesanspro-semibold text-lg" }
const _hoisted_22 = { class: "text-white/80 text-sm" }
const _hoisted_23 = { class: "flex items-center justify-between" }
const _hoisted_24 = { class: "text-white/70 text-sm" }
const _hoisted_25 = { class: "text-[#f9af21] font-sourcesanspro-bold text-xl" }
const _hoisted_26 = { class: "mb-8" }
const _hoisted_27 = { class: "text-white font-sourcesanspro-semibold text-base mb-3" }
const _hoisted_28 = { class: "space-y-2" }
const _hoisted_29 = { class: "flex items-start text-white/80 text-sm" }
const _hoisted_30 = { class: "flex items-start text-white/80 text-sm" }
const _hoisted_31 = { class: "flex items-start text-white/80 text-sm" }
const _hoisted_32 = {
  key: 2,
  class: "mb-8 text-center"
}
const _hoisted_33 = { class: "text-white/70" }
const _hoisted_34 = { class: "mb-8" }
const _hoisted_35 = { class: "flex w-full items-center justify-center" }
const _hoisted_36 = { class: "text-m2" }

import { useRoute } from 'vue-router';
import { computed, onMounted, watch } from 'vue';
import { IonButton, IonContent, IonIcon, IonSpinner } from '@ionic/vue';
import { closeOutline, trendingUpOutline } from 'ionicons/icons';
import { useI18n } from 'vue-i18n';

import { useCart } from '@/modules/shop/composables/useCart';
import { GenericProduct } from '@/shared/interfaces/genericProduct';
import useQueue from '@/modules/queue/composables/useQueue';
import { useCheckout } from '@/shared/composables/useCheckout';
import { useCartStore } from '@/stores/shop/cartStore';

// Init

export default /*@__PURE__*/_defineComponent({
  __name: 'QueueUpsellPage',
  setup(__props) {

const { t } = useI18n();
const route = useRoute();
const slotId = +route.params.slotId;
const activityId = +route.query.activityId;

const { getQueueActivity, getMyQueues } = useQueue();
const { activity, isFetchedActivity } = getQueueActivity(activityId);
const { myQueues, isFetchingMyQueues } = getMyQueues();
const { addToCart, getCartItems, getCartTotalItemsByCategory } = useCart();
const { processCheckout, handleCheckout: executeCheckout } = useCheckout();

// Find the slot being upgraded
const currentSlot = computed(() => {
	return myQueues.value?.find(s => s.id === slotId);
});

// Create upsell product that matches the expected interface
const upsellProduct = computed(() => {
	if (!activity.value || !activity.value.upsell_price || !activity.value.upsell_currency_id) {
		return null;
	}

	return new GenericProduct({
		id: activityId * 10000 + slotId, // Generate unique ID for upsell
		name: t('queue.upgrade_to_fastpass'),
		description: `${t('queue.upgrade_from_normal_to_fastpass')}`,
		price: activity.value.upsell_price / 100, // Convert from cents
		currency_id: activity.value.upsell_currency_id,
		currency: activity.value.upsellCurrency || {
			id: activity.value.upsell_currency_id,
			prefix: '€',
			suffix: '',
			exchange_rate: 1
		},
		vat_percentage: 0,
		order: 1
	});
});

// Track if item has been added
const itemAddedToCart = computed(() => getCartTotalItemsByCategory('queue_upsell'));

// Clear upsell items from cart on mount
onMounted(() => {
	const cartStore = useCartStore();
	// Remove only queue_upsell items from cart
	cartStore.cart = cartStore.cart.filter((item: any) => item.category !== 'queue_upsell');

	console.log('Cart cleared, cart size:', cartStore.cart.length);
});

// Function to add item to cart
const addItemToCart = () => {
	if (upsellProduct.value && isFetchedActivity.value && myQueues.value && itemAddedToCart.value === 0) {
		console.log('Adding upsell to cart:', upsellProduct.value);
		addToCart(upsellProduct.value, 'queue_upsell', {
			slotId: slotId,
			activityId: activityId,
		});
		console.log('Cart after add:', getCartTotalItemsByCategory('queue_upsell'));
	}
};

// Watch for all dependencies and trigger add
watch([upsellProduct, isFetchedActivity, () => myQueues.value], () => {
	console.log('Watch triggered:', {
		hasProduct: !!upsellProduct.value,
		fetched: isFetchedActivity.value,
		hasQueues: !!myQueues.value,
		cartItems: itemAddedToCart.value
	});

	addItemToCart();
});

// Also try to add on mount (with a slight delay to ensure data is loaded)
onMounted(async () => {
	// Wait a bit for data to load
	setTimeout(() => {
		console.log('Mount timeout - attempting to add to cart');
		addItemToCart();
	}, 100);
});

// Handle checkout
const handleCheckout = async () => {
	// Prepare the transaction data (sets up the store)
	await processCheckout('QUEUE_UPSELL', {
		slotId,
		activityId,
	});

	// Execute the actual checkout API call which will handle redirect
	await executeCheckout();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonContent), null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(IonButton), {
              class: "rounded ion-no-padding ion-no-margin w-[60px] h-[60px] hover:rounded-full hover:bg-white/20",
              routerLink: `/my-queues`
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonIcon), {
                  class: "text-[38px] text-white cursor-pointer",
                  icon: _unref(closeOutline)
                }, null, 8, ["icon"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(activity)?.name), 1)
        ]),
        (!_unref(isFetchedActivity) || _unref(isFetchingMyQueues))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_unref(IonSpinner), { name: "dots" })
            ]))
          : _createCommentVNode("", true),
        (_unref(activity) && currentSlot.value && _unref(isFetchedActivity) && upsellProduct.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)('queue.current_ticket')), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(t)('queue.regular_pass')), 1),
                      _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)('queue.position')) + ": #" + _toDisplayString(currentSlot.value.position_number), 1)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(t)('queue.estimated_wait_time')), 1),
                      _createElementVNode("p", _hoisted_15, _toDisplayString(currentSlot.value.estimated_wait_minutes || 0) + " min", 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_unref(IonIcon), {
                    class: "mr-2 text-[20px] text-white cursor-pointer",
                    icon: _unref(trendingUpOutline)
                  }, null, 8, ["icon"]),
                  _createElementVNode("h2", _hoisted_18, _toDisplayString(_unref(t)('queue.upgrade_option')), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_21, "⭐️ " + _toDisplayString(_unref(t)('queue.priority_pass')) + " ⭐️", 1),
                      _createElementVNode("p", _hoisted_22, _toDisplayString(upsellProduct.value.description), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("p", _hoisted_24, _toDisplayString(_unref(t)('queue.upgrade_price')), 1),
                    _createElementVNode("p", _hoisted_25, _toDisplayString(upsellProduct.value.currency.prefix) + _toDisplayString(upsellProduct.value.price.toFixed(2)) + _toDisplayString(upsellProduct.value.currency.suffix), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("h3", _hoisted_27, _toDisplayString(_unref(t)('queue.fastpass_benefits')), 1),
                _createElementVNode("ul", _hoisted_28, [
                  _createElementVNode("li", _hoisted_29, [
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-[#f9af21] mr-2" }, "✓", -1)),
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('queue.benefit_skip_line')), 1)
                  ]),
                  _createElementVNode("li", _hoisted_30, [
                    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-[#f9af21] mr-2" }, "✓", -1)),
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('queue.benefit_priority_access')), 1)
                  ]),
                  _createElementVNode("li", _hoisted_31, [
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-[#f9af21] mr-2" }, "✓", -1)),
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('queue.benefit_reduced_wait')), 1)
                  ])
                ])
              ])
            ]))
          : (_unref(activity) && _unref(isFetchedActivity) && !upsellProduct.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("p", _hoisted_33, _toDisplayString(_unref(t)('queue.upsell_not_available')), 1)
              ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_34, [
          (_unref(isFetchedActivity) && !_unref(isFetchingMyQueues))
            ? (_openBlock(), _createBlock(_unref(IonButton), {
                key: 0,
                disabled: itemAddedToCart.value === 0,
                class: "w-full hover:rounded-full hover:bg-white",
                expand: "full",
                size: "large",
                shape: "round",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (handleCheckout()))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("span", _hoisted_36, _toDisplayString(_unref(t)('queue.confirm_upgrade')), 1)
                  ])
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})